import { nextTick, onBeforeUnmount, watch } from 'vue'

// Scope keyboard interaction to the open modal and return to its trigger on close.
export function useModalFocus(element, isOpen, cancel) {
  let opener
  let active = false
  const controls = () => [...(element.value?.querySelectorAll(
    'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]',
  ) ?? [])].filter(node => !node.closest('[hidden], [inert]'))
  const focusFirst = () => (controls()[0] ?? element.value)?.focus()

  function keydown(event) {
    if (!active) return
    if (event.key === 'Escape') {
      event.preventDefault()
      event.stopImmediatePropagation()
      cancel()
    } else if (event.key === 'Tab') {
      const items = controls()
      const index = items.indexOf(document.activeElement)
      if (!items.length || index < 0 || (event.shiftKey ? index === 0 : index === items.length - 1)) {
        event.preventDefault()
        ;(event.shiftKey ? items.at(-1) : items[0])?.focus()
        if (!items.length) element.value?.focus()
      }
    }
  }
  function containFocus(event) {
    if (active && !element.value?.contains(event.target)) focusFirst()
  }
  function stop() {
    active = false
    document.removeEventListener('keydown', keydown, true)
    document.removeEventListener('focusin', containFocus)
    if (opener?.isConnected) opener.focus()
    opener = null
  }
  watch(isOpen, async open => {
    if (!open) { stop(); return }
    opener = document.activeElement
    active = true
    document.addEventListener('keydown', keydown, true)
    document.addEventListener('focusin', containFocus)
    await nextTick()
    if (active) focusFirst()
  }, { immediate: true })
  onBeforeUnmount(stop)
}
